import { Label, Layout, } from "@mcleod/components";

export abstract class AutogenLayoutDeclineCounterOffer extends Layout {
    labelStatus: Label;
}
